const LANG_LABEL = { en: 'English', it: 'italiano' };

/**
 * Generate adaptive question prompt for info gathering
 * @param {Object} node
 * @param {Array} collectedInfo - Array of {question, answer}
 * @param {string} [lang='en']
 * @returns {string}
 */
export const generateInfoGatheringPrompt = (node, collectedInfo, lang = 'en') => {
  const nodeTypeName = node.type === 'problem' ? 'argomento' : 'idea';

  const existingContext = collectedInfo.length > 0
    ? `\n\nConversazione:\n${collectedInfo.map((c, i) => `D${i + 1}: ${c.question}\nR${i + 1}: ${c.answer}`).join('\n')}`
    : '';

  const questionNumber = collectedInfo.length + 1;
  const progressionHint =
    questionNumber === 1
      ? 'Prima domanda: scopri il contesto o l\'importanza dell\'argomento.'
      : questionNumber === 2
      ? 'Seconda domanda: approfondisci l\'aspetto più critico emerso dalla risposta precedente.'
      : 'Terza domanda (ultima): chiedi del vincolo principale o del prossimo passo concreto.';

  return `Stai esplorando questo ${nodeTypeName}: "${node.title}" — ${node.summary}${existingContext}

${progressionHint}
Fai UNA domanda secca (max 12 parole) che segua logicamente dalla conversazione.
Non ripetere argomenti già coperti.

Solo JSON:
\`\`\`json
{"question": "..."}
\`\`\`

LINGUA: rispondi in ${LANG_LABEL[lang] ?? 'English'}.`;
};

/**
 * Generate synthesis prompt from collected Q&A
 * @param {string} title
 * @param {string} summary
 * @param {Array} collectedInfo - Array of {question, answer}
 * @param {string} [lang='en']
 * @returns {string}
 */
export const generateSynthesisPrompt = (title, summary, collectedInfo, lang = 'en') => {
  const qaText = collectedInfo.map((c, i) =>
    `${i + 1}. ${c.question}\n   → ${c.answer}`
  ).join('\n');

  return `Sintetizza in 2-4 frasi dense. No elenchi puntati, solo prosa.

"${title}" — ${summary}

Info raccolte:
${qaText}

Un paragrafo che integra tutto. Diretto, zero filler.

LINGUA: rispondi in ${LANG_LABEL[lang] ?? 'English'}.`;
};
